import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=117f5c64&scoped=true&"
import script from "./VideoSection.vue?vue&type=script&lang=js&"
export * from "./VideoSection.vue?vue&type=script&lang=js&"
import style0 from "./VideoSection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VideoSection.vue?vue&type=style&index=1&id=117f5c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f5c64",
  null
  
)

export default component.exports